function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.674 2.61C18.672.014 21.45 0 21.45 0s.413 2.443-1.572 4.796c-2.118 2.512-4.527 2.1-4.527 2.1s-.452-1.975 1.324-4.285zm-1.07 5.998c1.028 0 2.935-1.394 5.418-1.394 4.273 0 5.954 3 5.954 3s-3.288 1.66-3.288 5.684c0 4.54 4.096 6.106 4.096 6.106s-2.863 7.952-6.73 7.952c-1.777 0-3.158-1.181-5.03-1.181-1.906 0-3.799 1.225-5.032 1.225C7.463 30 3 22.457 3 16.393c0-5.966 3.776-9.095 7.318-9.095 2.303 0 4.09 1.31 5.286 1.31z"
});

var SvgIos = function SvgIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "5199bfa07b1dfbd650ee4e81e96c9548.svg";
export { SvgIos as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/ios.svg
// module id = null
// module chunks = 